import { Box, Typography } from '@mui/material'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import { useEffect, useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { getAllJobAds } from 'services/api/modules/recruitment/job-advertisment'

import JobAdsList from './JobAdsList'
import { useSearchParams } from 'react-router-dom'

const JobAds = ({ totalInCart }) => {
  //set query params (....../?type=)
  const [searchParams, setSearchParams] = useSearchParams({ type: 0 })
  const type = searchParams.get('type')
  // const row = parseInt(searchParams.get('row'), 10)
  // const page = parseInt(searchParams.get('page'), 10)
  const typeInteger = parseInt(type, 10) // The second argument is the radix (base), typically 10 for decimal numbers

  //search
  const [activeSearch, setActiveSearch] = useState('')
  const [inactiveSearch, setInactiveSearch] = useState('')
  const [draftSearch, setDraftSearch] = useState('')

  useEffect(() => {
    setActiveSearch('')
    setInactiveSearch('')
    setDraftSearch('')
  }, [type])

  //pagination for active page
  const [ActivePage, setActivePage] = useState(0)
  const [rowsPerActivePage, setRowsPerActivePage] = useState(10)
  const handleChangeActivePage = (event, newPage) => {
    setActivePage(newPage)
    setSearchParams((searchParams) => {
      searchParams.set('page', newPage + 1)
      return searchParams
    })
  }
  const handleChangeRowsPerActivePage = (event) => {
    setRowsPerActivePage(parseInt(event.target.value, 10))
    setActivePage(0)
    setSearchParams((searchParams) => {
      searchParams.set('row', event.target.value)
      return searchParams
    })
  }

  //pagination for draft page
  const [draftPage, setDraftPage] = useState(0)
  const [rowsPerDraftPage, setRowsPerDraftPage] = useState(10)
  const handleChangeDraftPage = (event, newPage) => {
    setDraftPage(newPage)
    setSearchParams((searchParams) => {
      searchParams.set('page', newPage + 1)
      return searchParams
    })
  }
  const handleChangeRowsPerDraftPage = (event) => {
    setRowsPerDraftPage(parseInt(event.target.value, 10))
    setDraftPage(0)
    setSearchParams((searchParams) => {
      searchParams.set('row', event.target.value)
      return searchParams
    })
  }

  //pagination for inactive page
  const [InactivePage, setInactivePage] = useState(0)
  const [rowsPerInactivePage, setRowsPerInactivePage] = useState(10)
  const handleChangeInactivePage = (event, newPage) => {
    setInactivePage(newPage)
    setSearchParams((searchParams) => {
      searchParams.set('page', newPage + 1)
      return searchParams
    })
  }
  const handleChangeRowsPerInactivePage = (event) => {
    setRowsPerInactivePage(parseInt(event.target.value, 10))
    setInactivePage(0)
    setSearchParams((searchParams) => {
      searchParams.set('row', event.target.value)
      return searchParams
    })
  }

  // API CALL
  const queryClient = useQueryClient()
  useEffect(() => {
    queryClient.invalidateQueries('getAllJobAds')
    queryClient.resetQueries('getAllJobAds')
  }, [])

  const {
    isLoading: activeIsLoading,
    error: activeError,
    data: activeData,
  } = useQuery(
    ['getAllJobAds', rowsPerActivePage, ActivePage, 'active', activeSearch],
    async () => {
      const { data } = await getAllJobAds('active', rowsPerActivePage, ActivePage + 1, activeSearch)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const {
    isLoading: inactiveIsLoading,
    error: inactiveError,
    data: inactiveData,
  } = useQuery(
    ['getAllJobAds', rowsPerInactivePage, InactivePage, 'inactive', inactiveSearch],
    async () => {
      const { data } = await getAllJobAds(
        'inactive',
        rowsPerInactivePage,
        InactivePage + 1,
        inactiveSearch
      )
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const {
    isLoading: draftIsLoading,
    error: draftError,
    data: draftData,
  } = useQuery(
    ['getAllJobAds', rowsPerDraftPage, draftPage, 'draft', draftSearch],
    async () => {
      const { data } = await getAllJobAds('draft', rowsPerDraftPage, draftPage + 1, draftSearch)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h4" fontWeight={700}>
        Jobs
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          bgcolor: 'white.main',
          border: 1,
          borderRadius: '4.5px',
          borderColor: 'gray-line.main',
        }}
      >
        <AdxTabsBadge
          searchParams={setSearchParams}
          queryParams={typeInteger}
          scrollButtons={false}
        >
          {/* active job ads  */}
          <AdxTabsPanel label="Active" notification={activeData?.total ?? '0'}>
            <JobAdsList
              type="active"
              handleChangePage={handleChangeActivePage}
              handleChangeRow={handleChangeRowsPerActivePage}
              data={activeData?.data}
              isLoading={activeIsLoading ?? []}
              error={activeError}
              count={activeData?.total}
              page={ActivePage}
              rowsPerPage={rowsPerActivePage}
              setSearch={setActiveSearch}
            />
          </AdxTabsPanel>
          {/* inactive job ads */}
          <AdxTabsPanel label="Inactive" notification={inactiveData?.total ?? '0'}>
            <JobAdsList
              type="inactive"
              data={inactiveData?.data}
              isLoading={inactiveIsLoading ?? []}
              error={inactiveError}
              totalInCart={totalInCart}
              count={inactiveData?.total}
              page={InactivePage}
              rowsPerPage={rowsPerInactivePage}
              handleChangePage={handleChangeInactivePage}
              handleChangeRow={handleChangeRowsPerInactivePage}
              setSearch={setInactiveSearch}
            />
          </AdxTabsPanel>

          {/* draft job ads */}
          <AdxTabsPanel label="Draft" notification={draftData?.total ?? '0'}>
            <JobAdsList
              type="draft"
              data={draftData?.data}
              isLoading={draftIsLoading ?? []}
              error={draftError}
              totalInCart={totalInCart}
              page={draftPage}
              count={draftData?.total}
              rowsPerPage={rowsPerDraftPage}
              handleChangePage={handleChangeDraftPage}
              handleChangeRow={handleChangeRowsPerDraftPage}
              setSearch={setDraftSearch}
            />
          </AdxTabsPanel>
        </AdxTabsBadge>
      </Box>
    </Box>
  )
}
export default JobAds
